<template>
  <div class="info">
    <h1></h1>
    <!-- <transition
      :duration="{ enter: 2500, leave: 1500 }"
      enter-active-class="animated fadeInUp">
      <div class="cont"  v-if="show">
        <h2>欢迎来到我的个人简历</h2>
        
      </div>
    </transition> -->
    <h2>欢迎来到我的个人简历</h2>
    <h2>出生日期:1990年6月</h2>
    <h2>QQ:188781475</h2>
    <div ref="typed">
      <span class="typing"></span>
    </div>
  
  </div>
</template>
<style scoped>
  .info {
  margin: 60px auto;
}
@media screen and (max-width: 768px) {
  .info {
    margin: 20px auto;
    height: 100%;
  }
}
.cont {
  margin: 20px auto;
  width: 60%;
}
.info {
  margin: 60px auto;
}
@media screen and (max-width: 768px) {
  .info {
    margin: 20px auto;
  }
}
.info .cont {
  width: 60%;
  margin: 20px auto;
  background-color: rgba(233, 225, 225, 0.3);
  border-radius: 25px;
}
.info .cont .avatar {
  width: 120px;
  height: 120px;
  border-radius: 60px;
  margin-top: 20px;
}
.info .cont .state {
  padding: 20px 10px 50px;
}
.info .cont .state .iconBox {
  width: 80px;
  height: 80px;
  border-radius: 40px;
  border: 1px solid rgba(9, 92, 49, 0.5);
  margin: 5px auto;
  background-color: rgba(13, 73, 87, 0.4);
}
.info .cont .state .iconBox:hover {
  background-color: rgba(13, 73, 87, 0.8);
}
.info .cont .state .iconBox .iconSet {
  font-size: 3rem;
  line-height: 80px;
  color: rgba(220, 228, 220, 0.7);
}
.info .cont .state .iconBox .iconSet:hover {
  font-size: 3.5rem;
  color: #dce4dc;
}

/* .ityped-cursor {
    font-size: 2.2rem;
    opacity: 1;
    -webkit-animation: blink 0.3s infinite;
    -moz-animation: blink 0.3s infinite;
    animation: blink 0.3s infinite;
    animation-direction: alternate;
} */

@keyframes blink {
    100% {
        opacity: 0;
    }
}

@-webkit-keyframes blink {
    100% {
        opacity: 0;
    }
}

@-moz-keyframes blink {
    100% {
        opacity: 0;
    }
}

</style>
<script>
import { init } from 'ityped'
export default {
  name: 'Main',
  data () {
    return {
      show: false,
      states: [
        {icon: 'el-icon-s-home', val: '年龄/30'},
        {icon: 'el-icon-document', val: '学历/本科'},
        {icon: 'icon-icon-', val: '坐标/四川会理'},
        {icon: 'icon-zhiwei', val: '状态/离职'}
      ]
    }
  },
  methods: {
    timeout () {
      setTimeout(() => {
        this.show = true
      }, 1000)
    },
    initTyped(){
      const $typed = this.$refs.typed.querySelector(".typing");
      init(this.$refs.typed, {showCursor: false, disableBackTyping: true,strings: ["我是90年的大龄码农，虽然年龄大了，但是热情尚在，技术虽然不精，但是就是喜欢折腾。我的座右铭：兢兢业业做事，踏踏实实做人"] });
    }
  },
  mounted () {
    this.initTyped();
  }
}
</script>


// WEBPACK FOOTER //
// src/components/index/Index.vue